module.exports = __webpack_public_path__ + "static/media/DF.5d3b37c2.jpg";